import React from "react";

function LoadingSpinnerxs() {
  return (
    <div className="spinner-container-xs">
      <div className="circles circles-one"></div>
      <div className="circles circles-two"></div>
      <div className="circles circles-three"></div>
    </div>
  );
}

export default LoadingSpinnerxs;
